import { render, staticRenderFns } from "./aLinkPagination.vue?vue&type=template&id=dd921116&scoped=true&"
import script from "./aLinkPagination.vue?vue&type=script&lang=js&"
export * from "./aLinkPagination.vue?vue&type=script&lang=js&"
import style0 from "./aLinkPagination.vue?vue&type=style&index=0&id=dd921116&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd921116",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
